import React, { Dispatch, useState } from "react"
import { Modal, Button, Row, Col, Select, Input, message, Radio } from "antd"
import { sendErrorEmail } from "../../api/errors/errors"
import { useUserContext } from "../../userContext"
import "./bugReport.css"

const { TextArea } = Input

const BugReport = (props: { openModal: boolean, setOpenModal: Dispatch<boolean> }) => {
  const { openModal, setOpenModal } = props
  const { user } = useUserContext()
  const [selected, setSelected] = useState<string>("default")
  const [value, setValue] = useState<string>("")

  const handleOk = async () => {
    if (selected === 'default') {
      return message.warn("Veuillez sélectionner un type de problème et décrire votre erreur")
    }
    if (user?.lastName)
      await sendErrorEmail(selected, value, user?.lastName)
    message.success("Votre erreur a été prise en compte.")
    setOpenModal(false)
  }

  const handleCancel = () => {
    setSelected("default")
    setOpenModal(false)
  }

  return (
    <Modal open={openModal} onOk={handleOk} onCancel={handleCancel}
      title="Signalez un problème"
      footer={[
        <Button key={"ok"} onClick={handleOk}>Envoyer</Button>,
        <Button key={"cancel"} onClick={handleCancel}>Annuler</Button>
      ]}
      width={1000}
      centered
    >
      <div>
        <Row>
          <Col xs={24} className='select-col'>
            <Radio.Group value={selected} onChange={e => setSelected(e.target.value)} className="select-container" >
              <Radio.Button style={{ marginRight: "0.5rem" }} key={"detection"} value="detection" >Probleme de detection</Radio.Button>
              <Radio.Button style={{ marginRight: "0.5rem" }} value="camera" key={"camera"}>Probleme de camera</Radio.Button>
              <Radio.Button style={{ marginRight: "0.5rem" }} value="internet" key={"internet"}>Probleme lié au réseau</Radio.Button>
              <Radio.Button value='other' key={"other"}>Autre</Radio.Button>
            </Radio.Group>
          </Col>
          <Col xs={24} className="comment-title">
            <span >
              Ajouter un commentaire:
            </span>
            <TextArea autoSize={{ minRows: 3, maxRows: 5 }}
              value={value}
              onChange={e => setValue(e.target.value)}
              placeholder="Commentaire"
            />
          </Col>
        </Row>
      </div>
    </Modal>
  )
}

export default BugReport